import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { OAuthProvider } from '@seapoint/server/enums';
import { Button } from '../../../../../design-system/button/button';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { Stack } from '../../../../../design-system/stack/stack';
import { exhaustiveCheck } from '../../../../../utils/exhaustive-check';
import { AllowedOAuthProvider } from '../../../../integrations/types/types';

type OAuthProviderDisconnectConfirmationModalProps = {
  provider: AllowedOAuthProvider;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onDisconnect: () => Promise<void>;
};

export const OAuthProviderDisconnectConfirmationModal = ({
  provider,
  isOpen,
  isLoading,
  onClose,
  onDisconnect,
}: OAuthProviderDisconnectConfirmationModalProps) => {
  const { title, ctaText } = getModalContent(provider);

  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px]">
        <VisuallyHidden>
          <ModalTitle>Disconnect email confirmation</ModalTitle>

          <ModalDescription>Disconnect email confirmation</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <Stack space={10} align="stretch" className="p-7">
          <Stack space={4} align="stretch">
            <h3 className="text-xl font-medium leading-6 tracking-tight text-black">{title}</h3>

            <p className="text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
              Are you sure you want to disconnect this account?
            </p>
          </Stack>

          <Button variant="destructive" isLoading={isLoading} onClick={onDisconnect}>
            {ctaText}
          </Button>
        </Stack>
      </ModalContent>
    </Modal>
  );
};

const getModalContent = (provider: AllowedOAuthProvider) => {
  switch (provider) {
    case OAuthProvider.GMAIL:
      return { title: 'Disconnect Gmail Account', ctaText: 'Disconnect email' };
    case OAuthProvider.XERO:
      return { title: 'Disconnect Xero Account', ctaText: 'Disconnect Xero' };
    default:
      return exhaustiveCheck(provider);
  }
};
